import { selectTitleNode } from '@newStore/documentUI/transformContent/genericSelectors';
import type { BuildingBlockNodeConfig } from '@nodeTypeConfig/configTypes';
import { descriptionComponent } from '@nodeTypeConfig/helpers/editComponents/descriptionComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const LLINKID_CONCORDANCE: BuildingBlockNodeConfig = {
  nodeSelector: selectTitleNode,
  information: {
    single: 'Concordantie (S)MD/BK',
    plural: 'Concordanties (S)MD/BK',
  },
  createDefaults: {
    title: 'Minimumdoelen, specifieke minimumdoelen of doelen die leiden naar BK',
  },
  buildingBlocks: [],
  edit: [
    titleComponent,
    {
      ...descriptionComponent,
      label: 'Concordaties',
    },
  ],
  isCollapsible: false,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
};

export default LLINKID_CONCORDANCE;
